import React from "react";
import { useQueryStateBoolean, useQueryStateNumber, useQueryStateString } from "routing/hooks";

export function usePageState(
  tableId?: string,
  disableQueryState?: boolean,
  initialPage?: number
): [number, (newState: number) => void] {
  const [page, setPage] = React.useState(initialPage ?? 0);
  const setPageState = (newState: number) => setPage(newState);

  const [queryPage, setQueryPage] = useQueryStateNumber(tableId ? `${tableId}_page` : `page`, 0);

  return disableQueryState ? [page, setPageState] : [queryPage, setQueryPage];
}

export function useRowsPerPageState(
  initialValue: number,
  tableId?: string,
  disableQueryState?: boolean
): [number, (newState: number) => void] {
  const [rowsPerPage, setRowsPerPage] = React.useState(initialValue);
  const setRowsPerPageState = (newState: number) => setRowsPerPage(newState);

  const [queryRowsPerPage, setQueryRowsPerPage] = useQueryStateNumber(
    tableId ? `${tableId}_rowsPerPage` : "rowsPerPage",
    initialValue
  );

  return disableQueryState ? [rowsPerPage, setRowsPerPageState] : [queryRowsPerPage, setQueryRowsPerPage];
}

export function useOrderByState(
  initialValue: string,
  tableId?: string,
  disableQueryState?: boolean
): [string, (newState: string) => void] {
  const [orderByProperty, setOrderByProperty] = React.useState(initialValue);
  const setOrderByPropertyState = (newState: string) => setOrderByProperty(newState);

  const [queryOrderByProperty, setQueryOrderByProperty] = useQueryStateString(
    tableId ? `${tableId}_orderBy` : "orderBy",
    initialValue,
    true
  );

  return disableQueryState
    ? [orderByProperty, setOrderByPropertyState]
    : [queryOrderByProperty, setQueryOrderByProperty];
}

export function useOrderByDescState(
  initialValue: boolean,
  tableId?: string,
  disableQueryState?: boolean
): [boolean, (newState: boolean) => void] {
  const [orderByDescending, setOrderByDescending] = React.useState(initialValue);
  const setOrderByDescendingState = (newState: boolean) => setOrderByDescending(newState);

  const [queryOrderByDescending, setQueryOrderByDescending] = useQueryStateBoolean(
    tableId ? `${tableId}_desc` : "desc",
    initialValue,
    true
  );

  return disableQueryState
    ? [orderByDescending, setOrderByDescendingState]
    : [queryOrderByDescending, setQueryOrderByDescending];
}
